import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteSitesQuery } from '@/modules/Sites';

interface Props extends AppAutocompleteComponentProps {
  excludeId?: string;
}

export const SitesAllAutocomplete: FC<Props> = memo(({ excludeId, ...props }) => {
  return (
    <AppAutocomplete<typeof useAutocompleteSitesQuery>
      { ...props }
      notFoundDescription="Немає сайтів"
      placeholder="Знайдіть сайт"
      excludedIds={ excludeId ? [excludeId] : undefined }
      options={
        (data) => parseSelectData(
          data?.map(({ id, name }) => ({ id, name })),
          { value: 'id', label: 'name' }
        )
      }
      query={ useAutocompleteSitesQuery }
    />
  );
});
